<template>
  <div class="features-introduce">
    <div class="introduce_title">
      <p class="introduce_title-top">管理纸箱厂的好帮手</p>
      <div class="introduce_title-line"></div>
      <p class="introduce_title-desc">让你省心一点 多赚一点</p>
      <div class="introduce_title-action">
        <div class="flex-center  action-trail" @click="freeUseClick">
          免费试用
        </div>
        <div class="flex-center  action-buy" @click="buyClick">立即购买</div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/utils'
export default {
  name: 'introduce',
  data() {
    return {
      isBigScreen: false
    }
  },
  created() {
    this.getIsBigScreen()
  },
  methods: {
    getIsBigScreen() {
      window.onresize = () => {
        this.isBigScreen = utils.isBigScreen()
      }
      this.isBigScreen = utils.isBigScreen()
    },
    freeUseClick() {
      this.$router.push({
        path: '/product/freeUse'
      })
    },
    buyClick() {
      this.$router.push({
        path: '/yzxBuyEntrance'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.features-introduce {
  width: 100%;
  background-image: url('../../../assets/images/productFeatures/bg_banner.png');
  background-position: center;
  background-size: cover;
  color: #ffffff;
  // height: 417px;

  .introduce_title {
    // padding-top: 55px;
    // padding-left: 60px;
    padding: 28px 0 40px 30px;
    &-top {
      font-family: AlimamaShuHeiTi;
      font-size: 32px;
      margin-bottom: 16px;
    }
    &-line {
      width: 32px;
      height: 2px;
      background: #0064eb;
      margin-bottom: 16px;
    }
    &-desc {
      font-size: 24px;
      margin-bottom: 16px;
    }
    &-action {
      display: flex;
      font-family: AlibabaPuHuiTi_2_55_Regular;
      font-size: 18px;
      .flex-center {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .action-trail {
        width: 124px;
        height: 38px;
        background: #0064eb;
        cursor: pointer;
      }
      .action-buy {
        margin-left: 16px;
        height: 38px;
        cursor: pointer;
      }
    }
  }
}
@media (min-width: 750px) and (max-width: 960px) {
  .features-introduce {
    // height: 729px;
    .introduce_title {
      // padding-top: 192px;
      // padding-left: 60px;
      padding: 150px 0 150px 100px;
      padding-left: 20%;
      &-top {
        // font-size: 60px;
        // line-height: 84px;
        margin-bottom: 32px;
      }
      &-line {
        width: 80px;
        height: 3px;
        background: #0064eb;
        margin-bottom: 32px;
      }
      &-desc {
        // font-size: 48px;
        // line-height: 67px;
        margin-bottom: 48px;
      }
      &-action {
        display: flex;
        // font-size: 36px;
        .flex-center {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .action-trail {
          width: 238px;
          height: 92px;
          background: #0064eb;
          cursor: pointer;
        }
        .action-buy {
          margin-left: 48px;
          height: 92px;
          cursor: pointer;
        }
      }
    }
  }
}
@media (min-width: 960px) {
  .features-introduce {
    // height: 729px;
    .introduce_title {
      // padding-top: 192px;
      // padding-left: 60px;
      padding: 150px 0 150px 100px;
      padding-left: 20%;
      &-top {
        font-size: 48px;
        // line-height: 84px;
        margin-bottom: 32px;
      }
      &-line {
        width: 80px;
        height: 3px;
        background: #0064eb;
        margin-bottom: 32px;
      }
      &-desc {
        font-size: 38px;
        // line-height: 67px;
        margin-bottom: 48px;
      }
      &-action {
        display: flex;
        font-size: 32px;
        .flex-center {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .action-trail {
          width: 208px;
          height: 72px;
          background: #0064eb;
          cursor: pointer;
        }
        .action-buy {
          margin-left: 48px;
          height: 72px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>

<style scoped></style>
